export enum TimeInterval {
  MONTH = 'Måned',
  QUARTER = 'Kvartal',
  YEAR = 'År',
}

export enum AdditionalRows {
  CURRENT_ACCOUNTING = 'Regnskap hittil',
  CURRENT_BUDGET = 'Budsjett',
}
